<div class="main">
        <div class="header">
          {{'DELETE_BILL.title' | translate}}
          <i class="material-icons" (click)="close();">clear</i>
        </div>
        <div class="section">
        <div class="form">
            <div class="formFiled">
                    <textarea class="input" name="reason" [(ngModel)]="reason" [placeholder]="'DELETE_BILL.reason' | translate"></textarea>
            </div> 
        </div>
          <div class="submitButton" (click)="deleteBill();" >
            <div class="button" style="background-color: #73235c;">
              {{'DELETE_BILL.delete' | translate}}
            </div>
          </div>
          <div class="submitButton" (click)="close();" style="float: right;margin-right: 10px;">
            <div class="button" style="background-color: #a0a0a0;">
              {{'DELETE_BILL.cancel' | translate}}
            </div>
          </div>
        </div>
      </div>
